import React from 'react'
import Info from '../../../assets/info.png'
import './InformationBox.scss'


function InformationBox({ title }) {
    return (
        <div className='info-box-container'>
            <img className='info-icon' src={Info} />
            <div className='information-title'>
                {title}
            </div>
        </div>
    )
}

export default InformationBox;